import React, {Component} from "react";
import {Form, Input , DatePicker,Message,TextArea} from 'antd';
import NHFormItem from '../common/NHFormItem';
import NHSelector from '../common/NHSelector';
import Moment  from 'moment';


/**
 * 快递单号管理编辑表单
 * @author JiangHaoRan
 * @date 2021年7月21日 17:00:58
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleAddStuBtnClick = () => {
        this.nhSelector.show();
    }

    handleStudentsSelectorOk = (selectObject) => {
        let { selectedNames, selectedKeys,} = selectObject;
        let xm=selectedNames[0]
        let xsid=selectedKeys[0]

        if (selectedKeys && selectedKeys.length >=2) {
           Message.error("请不要选择多于一个学生！")
        }else {
            this.props.form.setFieldsValue({
                xm:xm,
                xsid:xsid
            })
        }

    }


    render() {
        const {initFormData} = this.props;
        const { getFieldDecorator } = this.props.form;
        const  formItemLayout={
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
                md: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
            }
        }
        return (
            <div>
                <Form layout="horizontal">
                    <div style={{display:'none'}} >
                        <NHFormItem label="主键" id={"pkid"}
                                    form={this.props.form}  initialValue={initFormData.PKID} >
                            <Input  />
                        </NHFormItem>
                        <NHFormItem label="学生id" id={"xsid"}
                                    form={this.props.form}  initialValue={initFormData.XSID} >
                            <Input  />
                        </NHFormItem>

                    </div>
                            <NHFormItem label="姓名" id={"xm"}
                                        form={this.props.form}  initialValue={initFormData.XM ? initFormData.XM :""} required={true}>
                                <Input  readOnly="readOnly" onClick={this.handleAddStuBtnClick}  />
                            </NHFormItem>

                        <NHFormItem label="邮寄地址" id={"yjdz"}
                                    form={this.props.form}  initialValue={initFormData.YJDZ ? initFormData.YJDZ: ""} required={true}>
                            <Input  />
                        </NHFormItem>
                                <NHFormItem label="邮寄接收人" id={"yjjsr"}
                                            form={this.props.form}  initialValue={initFormData.YJJSR ? initFormData.YJJSR :""} required={true}>
                                    <Input  />
                                </NHFormItem>
                                <NHFormItem label="通知书编号" id={"tzsbh"}
                                            form={this.props.form}  initialValue={initFormData.TZSBH ? initFormData.TZSBH : ""} required={true}>
                                    <Input  />
                                </NHFormItem>
                                <NHFormItem label="快递单号" id={"kddh"}
                                            form={this.props.form}  initialValue={initFormData.KDDH ? initFormData.KDDH : ""} required={true}>
                                    <Input  />
                                </NHFormItem>
                                <Form.Item label="邮寄时间" {...formItemLayout}>
                                    {getFieldDecorator('yjsj',
                                        {initialValue: initFormData.YJSJ ?  Moment(initFormData.YJSJ ) :null ,
                                            rules: [{  required: true, message: '请选择时间！'}]},
                                    )(
                                        <DatePicker showTime format="YYYY-MM-DD"/>,
                                    )}
                                </Form.Item>
                    <NHSelector ref={selector => this.nhSelector = selector} title={'学生选择器'}
                                sign={"zhxg_yxxt_lcyyfw_student_selector"}
                                onOk={this.handleStudentsSelectorOk} />
                </Form>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/mailingManagement/EditForm.js